import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom'; // Import useNavigate
import JobCard from '../components/Job/JobCard';
import axios from 'axios';

const JobArea = () => {
  const URL = process.env.REACT_APP_API_URL;
  // const [AppliedJobs, setAppliedJobs] = useState({});
  const [UserAppliedJobs, setAppliedJob] = useState([]);
  // const UserId = localStorage.getItem('userid');
  const navigate = useNavigate(); // Initialize useNavigate
  const [wishList, setWishlist] = useState([{}]);
  const userid =localStorage.getItem("userid");
  const [loading, setLoading] = useState(false);
  
  // const getAppliedJobs = async (userid) => {
  //   try {
  //     const response = await axios.get(`${URL}job_application/byuserid/${userid}`);
  //     // console.log(response.data);
  //     setAppliedJobs(response.data);
  //   } catch (error) {
  //     console.error(error);
  //   }
  // }

  //  const getAllAppliedJobs = async() => {
  //     try {
  //       const response = await axios.get(`${process.env.REACT_APP_API_URL}jobs/getalljobs`)
  //       setAppliedJob(response.data);
  //     } catch (error) {
  //       console.log(error)
  //     }
  //   }

  const getRecentJobs = async () => {
    try {
      const response = await axios.get(`${URL}jobs/recentjobs`);
      setAppliedJob(response.data);
    } catch (error) {
      console.error(error);
    }
  };

  const fetchAllWishlistItems = async () => {
    try {
      setLoading(true);
      if(userid){
        const url = `${process.env.REACT_APP_API_URL}job_wishlist/getwishlistbyuserid/${userid}`;
        const response = await axios.get(url);
        setWishlist(response.data.data || []);
      }
    } catch (error) {
      console.error("Error fetching all jobs:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getRecentJobs() && fetchAllWishlistItems();
  }, []);
  const isInWishlist = (job_id) => {
    return wishList.some(wish => wish.job_id === job_id)};

  const handleShowMoreJobs = () => {
    navigate('/jobs'); // Navigate to /jobs route
  };

  return (
    <div className="job-area bg py-120">
      <div className="container">
        <div className="row">
          <div className="col-lg-6 mx-auto wow fadeInDown">
            <div className="site-heading text-center">
              <span className="site-title-tagline">Recent Jobs</span>
              <h2 className="site-title">Find Your Dream Job</h2>
              <p>Know Your Worth And Find The Job That Qualify Your Life</p>
            </div>
          </div>
        </div>
        <div className="row">
          {UserAppliedJobs.length > 0 ? UserAppliedJobs.map((job) => (
            <JobCard key={job.job_id} job={job} isInWishlist={isInWishlist}/>
          )) : <p className="text-center">No recent jobs available</p>}
        </div>
        {/* {jobs.length > 0 && jobs.map((data,index)=>{
      return (
      <div  key={index} className="col-lg-6 col-xl-4">
        <div className="job-item">
          <a href="#" className="job-bookmark">
            <i className="fe-bookmark" />
          </a>
          <div className="job-top">
            <div className="job-img">
              <img src="assets/img/job/01.jpg" alt="" />
            </div>
            <div className="job-title">
              <h6>
                <a href="#">{data.role}</a>
              </h6>
              <a href="#" className="job-employer">
                <i className="far fa-building" /> {data.industry}
              </a>
            </div>
          </div>
          <div className="job-content">
            <ul className="job-info-list">
              <li>
                <i className="fe-briefcase" /> {data.department}
              </li>
              <li>
                <i className="fe-check-circle" /> {data.job_type}
              </li>
              <li>
                <i className="fe-clock" /> 2 Hour Ago
              </li>
              <li>
                <i className="fe-map-pin" /> {data.city}
              </li>
            </ul>
            <div className="job-skill">
              <a href="#">{data.skills}</a>
             
            </div>
          </div>
          <div className="job-bottom">
            <div className="job-salary">
              <span className="job-salary-amount">{data.package}</span>{" "}
              <span className="job-salary-type">/Hour</span>
            </div>

            {AppliedJobs.length > 0 &&
                AppliedJobs.some((app_job, index) => app_job.job_id == data.job_id ) ? (
                <span key={index} class="btn btn-success" disabled>Applied</span>)
                :
                 (
                  <a href="#" className="theme-btn" onClick={() =>addApplication(data.job_id)}>
                    Apply Now
                  </a>
                 )
            }
          </div>
        </div>
      </div>
      );
 })} */}
      {/* <div className="col-lg-6 col-xl-4">
        <div className="job-item">
          <a href="#" className="job-bookmark">
            <i className="fe-bookmark" />
          </a>
          <div className="job-top">
            <div className="job-img">
              <img src="assets/img/job/02.jpg" alt="" />
            </div>
            <div className="job-title">
              <h5>
                <a href="#">Finance Manager</a>
              </h5>
              <a href="#" className="job-employer">
                <i className="far fa-building" /> Turbo Finance
              </a>
            </div>
          </div>
          <div className="job-content">
            <ul className="job-info-list">
              <li>
                <i className="fe-briefcase" /> Finance
              </li>
              <li>
                <i className="fe-check-circle" /> Full Time
              </li>
              <li>
                <i className="fe-alert-triangle" /> Urgent
              </li>
              <li>
                <i className="fe-clock" /> 2 Hour Ago
              </li>
              <li>
                <i className="fe-map-pin" /> 25/B Milford Road, New York
              </li>
            </ul>
            <div className="job-skill">
              <a href="#">Figma</a>
              <a href="#">Photoshop</a>
              <a href="#">Adobe XD</a>
            </div>
          </div>
          <div className="job-bottom">
            <div className="job-salary">
              <span className="job-salary-amount">$150 - $180</span>{" "}
              <span className="job-salary-type">/Hour</span>
            </div>
            <a href="#" className="theme-btn">
              Apply Now
            </a>
          </div>
        </div>
      </div> */}
      {/* <div className="col-lg-6 col-xl-4">
        <div className="job-item">
          <a href="#" className="job-bookmark">
            <i className="fe-bookmark" />
          </a>
          <div className="job-top">
            <div className="job-img">
              <img src="assets/img/job/03.jpg" alt="" />
            </div>
            <div className="job-title">
              <h5>
                <a href="#">Marketing Manager</a>
              </h5>
              <a href="#" className="job-employer">
                <i className="far fa-building" /> Azutine Growths
              </a>
            </div>
          </div>
          <div className="job-content">
            <ul className="job-info-list">
              <li>
                <i className="fe-briefcase" /> Marketing
              </li>
              <li>
                <i className="fe-check-circle" /> Freelance
              </li>
              <li>
                <i className="fe-clock" /> 2 Hour Ago
              </li>
              <li>
                <i className="fe-map-pin" /> 25/B Milford Road, New York
              </li>
            </ul>
            <div className="job-skill">
              <a href="#">Figma</a>
              <a href="#">Photoshop</a>
              <a href="#">Adobe XD</a>
            </div>
          </div>
          <div className="job-bottom">
            <div className="job-salary">
              <span className="job-salary-amount">$150 - $180</span>{" "}
              <span className="job-salary-type">/Hour</span>
            </div>
            <a href="#" className="theme-btn">
              Apply Now
            </a>
          </div>
        </div>
      </div> */}
      {/* <div className="col-lg-6 col-xl-4">
        <div className="job-item">
          <a href="#" className="job-bookmark">
            <i className="fe-bookmark" />
          </a>
          <div className="job-top">
            <div className="job-img">
              <img src="assets/img/job/04.jpg" alt="" />
            </div>
            <div className="job-title">
              <h5>
                <a href="#">Product Designer</a>
              </h5>
              <a href="#" className="job-employer">
                <i className="far fa-building" /> Larana Inc
              </a>
            </div>
          </div>
          <div className="job-content">
            <ul className="job-info-list">
              <li>
                <i className="fe-briefcase" /> Design
              </li>
              <li>
                <i className="fe-check-circle" /> Internship
              </li>
              <li>
                <i className="fe-clock" /> 2 Hour Ago
              </li>
              <li>
                <i className="fe-map-pin" /> 25/B Milford Road, New York
              </li>
            </ul>
            <div className="job-skill">
              <a href="#">Figma</a>
              <a href="#">Photoshop</a>
              <a href="#">Adobe XD</a>
            </div>
          </div>
          <div className="job-bottom">
            <div className="job-salary">
              <span className="job-salary-amount">$150 - $180</span>{" "}
              <span className="job-salary-type">/Hour</span>
            </div>
            <a href="#" className="theme-btn">
              Apply Now
            </a>
          </div>
        </div>
      </div> */}
      {/* <div className="col-lg-6 col-xl-4">
        <div className="job-item">
          <a href="#" className="job-bookmark">
            <i className="fe-bookmark" />
          </a>
          <div className="job-top">
            <div className="job-img">
              <img src="assets/img/job/05.jpg" alt="" />
            </div>
            <div className="job-title">
              <h5>
                <a href="#">Creative Director</a>
              </h5>
              <a href="#" className="job-employer">
                <i className="far fa-building" /> Rubic Corner
              </a>
            </div>
          </div>
          <div className="job-content">
            <ul className="job-info-list">
              <li>
                <i className="fe-briefcase" /> Design
              </li>
              <li>
                <i className="fe-check-circle" /> Full Time
              </li>
              <li>
                <i className="fe-clock" /> 2 Hour Ago
              </li>
              <li>
                <i className="fe-map-pin" /> 25/B Milford Road, New York
              </li>
            </ul>
            <div className="job-skill">
              <a href="#">Figma</a>
              <a href="#">Photoshop</a>
              <a href="#">Adobe XD</a>
            </div>
          </div>
          <div className="job-bottom">
            <div className="job-salary">
              <span className="job-salary-amount">$150 - $180</span>{" "}
              <span className="job-salary-type">/Hour</span>
            </div>
            <a href="#" className="theme-btn">
              Apply Now
            </a>
          </div>
        </div>
      </div> */}
      {/* <div className="col-lg-6 col-xl-4">
        <div className="job-item">
          <a href="#" className="job-bookmark">
            <i className="fe-bookmark" />
          </a>
          <div className="job-top">
            <div className="job-img">
              <img src="assets/img/job/06.jpg" alt="" />
            </div>
            <div className="job-title">
              <h5>
                <a href="#">Software Engineer</a>
              </h5>
              <a href="#" className="job-employer">
                <i className="far fa-building" /> Mariana Cahaya
              </a>
            </div>
          </div>
          <div className="job-content">
            <ul className="job-info-list">
              <li>
                <i className="fe-briefcase" /> Design
              </li>
              <li>
                <i className="fe-check-circle" /> Full Time
              </li>
              <li>
                <i className="fe-clock" /> 2 Hour Ago
              </li>
              <li>
                <i className="fe-map-pin" /> 25/B Milford Road, New York
              </li>
            </ul>
            <div className="job-skill">
              <a href="#">Java</a>
              <a href="#">Python</a>
              <a href="#">AWS</a>
            </div>
          </div>
          <div className="job-bottom">
            <div className="job-salary">
              <span className="job-salary-amount">$150 - $180</span>{" "}
              <span className="job-salary-type">/Hour</span>
            </div>
            <a href="#" className="theme-btn">
              Apply Now
            </a>
          </div>
        </div>
      </div> */}
      {/* <div className="col-lg-6 col-xl-4">
        <div className="job-item">
          <a href="#" className="job-bookmark">
            <i className="fe-bookmark" />
          </a>
          <div className="job-top">
            <div className="job-img">
              <img src="assets/img/job/07.jpg" alt="" />
            </div>
            <div className="job-title">
              <h5>
                <a href="#">Web Developer</a>
              </h5>
              <a href="#" className="job-employer">
                <i className="far fa-building" /> Ladang Tech
              </a>
            </div>
          </div>
          <div className="job-content">
            <ul className="job-info-list">
              <li>
                <i className="fe-briefcase" /> Development
              </li>
              <li>
                <i className="fe-check-circle" /> Full Time
              </li>
              <li>
                <i className="fe-clock" /> 2 Hour Ago
              </li>
              <li>
                <i className="fe-map-pin" /> 25/B Milford Road, New York
              </li>
            </ul>
            <div className="job-skill">
              <a href="#">Vue Js</a>
              <a href="#">Node Js</a>
              <a href="#">MySql</a>
            </div>
          </div>
          <div className="job-bottom">
            <div className="job-salary">
              <span className="job-salary-amount">$150 - $180</span>{" "}
              <span className="job-salary-type">/Hour</span>
            </div>
            <a href="#" className="theme-btn">
              Apply Now
            </a>
          </div>
        </div>
      </div> */}
      {/* <div className="col-lg-6 col-xl-4">
        <div className="job-item">
          <a href="#" className="job-bookmark">
            <i className="fe-bookmark" />
          </a>
          <div className="job-top">
            <div className="job-img">
              <img src="assets/img/job/08.jpg" alt="" />
            </div>
            <div className="job-title">
              <h5>
                <a href="#">Techincal Support</a>
              </h5>
              <a href="#" className="job-employer">
                <i className="far fa-building" /> Wardiere Inc
              </a>
            </div>
          </div>
          <div className="job-content">
            <ul className="job-info-list">
              <li>
                <i className="fe-briefcase" /> Design
              </li>
              <li>
                <i className="fe-check-circle" /> Full Time
              </li>
              <li>
                <i className="fe-clock" /> 2 Hour Ago
              </li>
              <li>
                <i className="fe-map-pin" /> 25/B Milford Road, New York
              </li>
            </ul>
            <div className="job-skill">
              <a href="#">Figma</a>
              <a href="#">Photoshop</a>
              <a href="#">Adobe XD</a>
            </div>
          </div>
          <div className="job-bottom">
            <div className="job-salary">
              <span className="job-salary-amount">$150 - $180</span>{" "}
              <span className="job-salary-type">/Hour</span>
            </div>
            <a href="#" className="theme-btn">
              Apply Now
            </a>
          </div>
        </div>
      </div> */}
      {/* <div className="col-lg-6 col-xl-4">
        <div className="job-item">
          <a href="#" className="job-bookmark">
            <i className="fe-bookmark" />
          </a>
          <div className="job-top">
            <div className="job-img">
              <img src="assets/img/job/09.jpg" alt="" />
            </div>
            <div className="job-title">
              <h5>
                <a href="#">Social Media Expert</a>
              </h5>
              <a href="#" className="job-employer">
                <i className="far fa-building" /> Fire Digital
              </a>
            </div>
          </div>
          <div className="job-content">
            <ul className="job-info-list">
              <li>
                <i className="fe-briefcase" /> Design
              </li>
              <li>
                <i className="fe-check-circle" /> Full Time
              </li>
              <li>
                <i className="fe-clock" /> 2 Hour Ago
              </li>
              <li>
                <i className="fe-map-pin" /> 25/B Milford Road, New York
              </li>
            </ul>
            <div className="job-skill">
              <a href="#">Figma</a>
              <a href="#">Photoshop</a>
              <a href="#">Adobe XD</a>
            </div>
          </div>
          <div className="job-bottom">
            <div className="job-salary">
              <span className="job-salary-amount">$150 - $180</span>{" "}
              <span className="job-salary-type">/Hour</span>
            </div>
            <a href="#" className="theme-btn">
              Apply Now
            </a>
          </div>
        </div>
      </div>
       */}
          <div className="row mt-4">
            <div className="col text-center">
              <button className="theme-btn" onClick={handleShowMoreJobs}>
                Show More Jobs
              </button>
            </div>
          </div>
        
      </div>
    </div>
  );
};

export default JobArea;
